import { ArrowRight, Instagram, Facebook, MapPin } from "lucide-react";
import { Link } from "react-router-dom";
import { BRAND } from "@/lib/constants";

const STATS = [
  { value: "1-2-1", label: "Private coaching, undivided focus" },
  { value: "8–80+", label: "Kids sessions to senior rehab" },
  { value: "100%", label: "Private studio — no crowds" },
];

export const Hero = () => {
  return (
    <section
      id="home"
      data-testid="hero-section"
      className="relative min-h-[100vh] w-full overflow-hidden flex flex-col justify-end noise-overlay"
    >
      <div className="absolute inset-0">
        <img
          src="https://customer-assets.emergentagent.com/job_je-fitness-hub/artifacts/98gp6ohr_IMG_8098.jpeg"
          alt=""
          className="h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-zinc-950/70" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#09090B] via-zinc-950/50 to-zinc-950/30" />
      </div>

      <div className="relative z-10 w-full max-w-[1400px] mx-auto px-6 lg:px-10 pt-40 pb-16">
        <div className="fade-in-up">
          <div className="flex items-center gap-3 mb-6">
            <span className="h-[2px] w-12 bg-[#D4AF37]" />
            <p className="font-display text-[#D4AF37] text-sm font-bold tracking-[0.3em] uppercase">
              Private Personal Training — Braintree, Essex
            </p>
          </div>

          <h1
            data-testid="hero-heading"
            className="font-display text-white font-black uppercase leading-[0.85] tracking-tight text-[16vw] sm:text-8xl lg:text-[10rem]"
          >
            Built on <span className="text-[#D4AF37]">strength.</span>
            <br />
            Driven by togetherness.
          </h1>

          <div className="mt-10 flex flex-col lg:flex-row lg:items-end lg:justify-between gap-10">
            <p className="max-w-xl text-zinc-300 text-base sm:text-lg leading-relaxed font-light">
              One coach. One private studio. Every session engineered around
              you — from 1-2-1 transformations and small-group strength to
              senior rehabilitation and junior athletes.
            </p>

            <div className="flex flex-wrap items-center gap-4 shrink-0">
              <a
                href="#contact"
                data-testid="hero-primary-cta"
                className="group inline-flex items-center gap-3 bg-[#D4AF37] hover:bg-[#F3CE56] text-zinc-950 px-8 py-4 font-display text-base font-bold uppercase tracking-[0.16em] transition-colors duration-300"
              >
                Enquire Now
                <ArrowRight
                  size={18}
                  strokeWidth={2}
                  className="transition-transform duration-300 group-hover:translate-x-1"
                />
              </a>
              <Link
                to="/book"
                data-testid="hero-secondary-cta"
                className="inline-flex items-center gap-3 border border-zinc-600 hover:border-[#D4AF37] text-white px-8 py-4 font-display text-base font-bold uppercase tracking-[0.16em] transition-colors duration-300"
              >
                Book A Session
              </Link>
            </div>
          </div>

          <div className="mt-10 flex flex-wrap items-center gap-x-8 gap-y-3 text-zinc-400 text-sm">
            <span className="inline-flex items-center gap-2">
              <MapPin size={15} strokeWidth={1.5} className="text-[#D4AF37]" />
              {BRAND.location}
            </span>
            <a
              href={BRAND.instagram}
              target="_blank"
              rel="noreferrer"
              data-testid="hero-instagram-link"
              className="inline-flex items-center gap-2 hover:text-white transition-colors"
            >
              <Instagram size={15} strokeWidth={1.5} /> @jetraining_
            </a>
            <a
              href={BRAND.facebook}
              target="_blank"
              rel="noreferrer"
              data-testid="hero-facebook-link"
              className="inline-flex items-center gap-2 hover:text-white transition-colors"
            >
              <Facebook size={15} strokeWidth={1.5} /> Facebook
            </a>
          </div>
        </div>
      </div>

      {/* Stat strip */}
      <div className="relative z-10 border-t border-zinc-800 bg-zinc-950/80 backdrop-blur-md">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 grid grid-cols-1 sm:grid-cols-3 divide-y sm:divide-y-0 sm:divide-x divide-zinc-800">
          {STATS.map((s, i) => (
            <div
              key={i}
              data-testid={`hero-stat-${i}`}
              className="py-5 sm:py-6 sm:px-8 first:pl-0 flex items-baseline gap-4"
            >
              <span className="font-display text-[#D4AF37] text-3xl lg:text-4xl font-black tracking-tight">
                {s.value}
              </span>
              <span className="text-zinc-400 text-xs sm:text-sm font-light">
                {s.label}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Hero;
